import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosBackend from "../api/axiosBackend";

// Create AuthContext
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await axiosBackend.get("/auth/me", { withCredentials: true });
                setUser(res.data);
            } catch (error) {
                console.error("Authentication failed", error);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    const login = () => {
        window.location.href = `${axiosBackend.defaults.baseURL}/auth/google`; // Redirect to Google OAuth
    };

    const logout = async () => {
        try {
            await axiosBackend.get("/auth/logout", { withCredentials: true });
            setUser(null);
            console.log("User logged out successfully");
        } catch (error) {
            console.error("Logout failed:", error.response?.data);
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
